import { SentryErrorBoundary } from '../../services/errorTracking';
import './AppErrorBoundary.css';

// Envolvemos la app en este boundary para que cualquier excepción no
// atrapada en el árbol React (a) se reporte a Sentry automáticamente y
// (b) muestre una UI mínima en lugar de pantalla en blanco.
export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <SentryErrorBoundary
      fallback={({ resetError }) => (
        <div className="app-error-fallback">
          <div className="app-error-fallback__icon">
            <svg viewBox="0 0 24 24" fill="currentColor" width="56" height="56">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
          </div>
          <h1 className="app-error-fallback__title">Algo ha ido mal</h1>
          <p className="app-error-fallback__desc">
            Hemos registrado el problema. Pulsa "Reintentar" para volver a la app.
          </p>
          <div className="app-error-fallback__actions">
            <button className="app-error-fallback__btn" onClick={resetError}>Reintentar</button>
            <button
              className="app-error-fallback__btn app-error-fallback__btn--secondary"
              onClick={() => window.location.reload()}
            >
              Recargar la app
            </button>
          </div>
        </div>
      )}
    >
      {children}
    </SentryErrorBoundary>
  );
}
